import React, { useState, useEffect } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',RED='#EF4444';
const s = {
  card:{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'14px',padding:'18px 22px',marginBottom:'12px'},
  btn:{padding:'9px 20px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'9px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};

const URGENCY = [
  {val:'normal',label:'Normal (3-5 zile)',color:NAVY},
  {val:'urgent',label:'🚨 Urgent (24h)',color:'#D97706'},
  {val:'very_urgent',label:'🔴 Foarte urgent (acum)',color:RED},
];

const TYPE_LABELS = {
  piese_auto:{label:'Piesă auto',icon:'🔩'},
  service:{label:'Service / Manoperă',icon:'🔧'},
  anvelope:{label:'Anvelope',icon:'🛞'},
  itp:{label:'ITP / Inspecție',icon:'🔍'},
  rca_casco:{label:'Asigurare RCA/CASCO',icon:'🛡️'},
  rovinieta:{label:'Rovinieta',icon:'🛣️'},
  inmatriculare:{label:'Înmatriculare',icon:'📋'},
  transport:{label:'Transport / Remorcare',icon:'🚛'},
};

export default function MarketplacePage() {
  const [view, setView] = useState('list'); // list | new | offers
  const [requests, setRequests] = useState([]);
  const [services, setServices] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [offers, setOffers] = useState([]);
  const [form, setForm] = useState({vehicle_id:'',request_type:'',description:'',urgency:'normal',budget_ron:'',location:'Iași'});
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadRequests();
    api('/marketplace/services').then(d => d.services && setServices(d.services));
    api('/vehicles').then(d => d.vehicles && setVehicles(d.vehicles));
  }, []);

  const loadRequests = async () => {
    const data = await api('/marketplace/requests');
    if (data.requests) setRequests(data.requests);
  };

  const submitRequest = async () => {
    if (!form.request_type || !form.description) { setMsg('Completează tipul și descrierea!'); return; }
    setLoading(true);
    const data = await api('/marketplace/requests', { method:'POST', body: JSON.stringify(form) });
    if (data.request) {
      setMsg('✓ ' + data.message);
      setView('list');
      loadRequests();
      setForm({vehicle_id:'',request_type:'',description:'',urgency:'normal',budget_ron:'',location:'Iași'});
    } else { setMsg(data.error || 'Eroare la trimitere'); }
    setLoading(false);
  };

  const loadOffers = async (req) => {
    setSelectedRequest(req);
    const data = await api(`/marketplace/requests/${req.id}/offers`);
    if (data.offers) setOffers(data.offers);
    setView('offers');
  };

  const acceptOffer = async (offerId) => {
    const data = await api(`/marketplace/requests/${selectedRequest.id}/accept/${offerId}`, { method:'POST' });
    if (data.offer) {
      setMsg('✓ Ofertă acceptată! Numărul de telefon este acum vizibil.');
      loadOffers(selectedRequest);
    }
  };

  const statusColors = { active:'#FEF3DC', accepted:'#DCFCE7', closed:'#F4F4F4' };
  const statusLabels = { active:'Activ', accepted:'Acceptat', closed:'Închis' };

  if (view === 'new') return (
    <div>
      <button onClick={()=>setView('list')} style={{...s.btn,background:'transparent',border:'0.5px solid #D3D1C7',color:'#555',marginBottom:'14px',fontSize:'12px'}}>← Înapoi</button>
      <div style={{fontSize:'20px',fontWeight:800,marginBottom:'14px'}}>📤 Solicitare nouă</div>

      <div style={s.card}>
        <div style={{marginBottom:'14px'}}>
          <label style={s.label}>Tip serviciu *</label>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'8px',marginTop:'6px'}}>
            {Object.entries(TYPE_LABELS).map(([key,val]) => (
              <div key={key} onClick={()=>setForm({...form,request_type:key})}
                style={{border:`1.5px solid ${form.request_type===key?GOLD:'#D3D1C7'}`,background:form.request_type===key?'#FEF3DC':'#fff',borderRadius:'10px',padding:'10px',textAlign:'center',cursor:'pointer'}}>
                <div style={{fontSize:'20px',marginBottom:'4px'}}>{val.icon}</div>
                <div style={{fontSize:'11px',fontWeight:700}}>{val.label}</div>
              </div>
            ))}
          </div>
        </div>

        {vehicles.length > 0 && (
          <div style={{marginBottom:'12px'}}>
            <label style={s.label}>Mașina (opțional)</label>
            <select style={s.input} value={form.vehicle_id} onChange={e=>setForm({...form,vehicle_id:e.target.value})}>
              <option value=''>Fără mașină specificată</option>
              {vehicles.map(v => <option key={v.id} value={v.id}>{v.plate_number} · {v.brand} {v.model} {v.year}</option>)}
            </select>
          </div>
        )}

        <div style={{marginBottom:'12px'}}>
          <label style={s.label}>Descriere detaliată *</label>
          <textarea value={form.description} onChange={e=>setForm({...form,description:e.target.value})}
            style={{...s.input,minHeight:'100px',resize:'vertical'}}
            placeholder="Descrie exact ce ai nevoie — cu cât ești mai detaliat, cu atât primești oferte mai bune..."/>
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'12px'}}>
          <div>
            <label style={s.label}>Urgență</label>
            <select style={s.input} value={form.urgency} onChange={e=>setForm({...form,urgency:e.target.value})}>
              {URGENCY.map(u => <option key={u.val} value={u.val}>{u.label}</option>)}
            </select>
          </div>
          <div>
            <label style={s.label}>Buget estimat (lei, opțional)</label>
            <input style={s.input} type="number" placeholder="ex: 500" value={form.budget_ron} onChange={e=>setForm({...form,budget_ron:e.target.value})}/>
          </div>
        </div>

        <div style={{marginBottom:'14px'}}>
          <label style={s.label}>Locație</label>
          <input style={s.input} value={form.location} onChange={e=>setForm({...form,location:e.target.value})} placeholder="Iași"/>
        </div>

        {msg && <div style={{background:msg.includes('✓')?'#DCFCE7':'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:msg.includes('✓')?'#15803D':'#B91C1C',marginBottom:'12px'}}>{msg}</div>}

        <div style={{display:'flex',gap:'8px'}}>
          <button onClick={submitRequest} disabled={loading} style={{...s.btn,background:GOLD,color:DARK}}>
            {loading ? 'Se trimite...' : 'Trimite solicitarea →'}
          </button>
          <button onClick={()=>setView('list')} style={{...s.btn,background:'transparent',border:'0.5px solid #D3D1C7',color:'#555'}}>Anulează</button>
        </div>
      </div>
    </div>
  );

  if (view === 'offers') return (
    <div>
      <button onClick={()=>setView('list')} style={{...s.btn,background:'transparent',border:'0.5px solid #D3D1C7',color:'#555',marginBottom:'14px',fontSize:'12px'}}>← Înapoi la solicitări</button>

      <div style={{background:NAVY,borderRadius:'14px',padding:'16px 20px',marginBottom:'14px'}}>
        <div style={{color:'rgba(255,255,255,.6)',fontSize:'12px',marginBottom:'4px'}}>{TYPE_LABELS[selectedRequest?.request_type]?.icon} {TYPE_LABELS[selectedRequest?.request_type]?.label}</div>
        <div style={{color:'#fff',fontSize:'16px',fontWeight:700,marginBottom:'4px'}}>{selectedRequest?.description?.substring(0,100)}...</div>
        <div style={{color:'rgba(255,255,255,.5)',fontSize:'11px'}}>📍 {selectedRequest?.location} · {offers.length} oferte primite</div>
      </div>

      {msg && <div style={{background:'#DCFCE7',borderRadius:'8px',padding:'10px',fontSize:'12px',color:'#15803D',marginBottom:'12px'}}>{msg}</div>}

      {offers.length === 0 ? (
        <div style={{...s.card,textAlign:'center',padding:'32px'}}>
          <div style={{fontSize:'40px',marginBottom:'10px'}}>⏳</div>
          <div style={{fontWeight:700,marginBottom:'4px'}}>Așteptăm oferte</div>
          <div style={{fontSize:'12px',color:'#888'}}>Colaboratorii au fost notificați și vor răspunde în curând.</div>
        </div>
      ) : offers.map((offer,i) => (
        <div key={offer.id} style={{...s.card,border:offer.is_accepted?`2px solid ${GREEN}`:i===0?`2px solid ${GOLD}`:'0.5px solid #D3D1C7',background:offer.is_accepted?'#DCFCE7':i===0?'#FEF3DC':'#fff'}}>
          {i===0 && !offer.is_accepted && <div style={{fontSize:'10px',fontWeight:700,color:GOLD,marginBottom:'8px'}}>⭐ CEL MAI BUN PREȚ</div>}
          {offer.is_accepted && <div style={{fontSize:'10px',fontWeight:700,color:'#15803D',marginBottom:'8px'}}>✓ OFERTĂ ACCEPTATĂ</div>}

          <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',marginBottom:'8px'}}>
            <div>
              <div style={{fontSize:'15px',fontWeight:800}}>{offer.company_name}</div>
              {offer.rating && <div style={{fontSize:'11px',color:GOLD}}>{'★'.repeat(Math.round(offer.rating))} {offer.rating} · {offer.review_count} recenzii</div>}
            </div>
            <div style={{textAlign:'right'}}>
              <div style={{fontSize:'24px',fontWeight:900}}>{offer.price_ron} lei</div>
              <div style={{fontSize:'10px',color:'#888'}}>+ TVA</div>
            </div>
          </div>

          <div style={{fontSize:'12px',color:'#555',lineHeight:1.6,background:'#F4F4F4',padding:'10px',borderRadius:'8px',marginBottom:'8px'}}>{offer.description}</div>

          <div style={{display:'flex',gap:'12px',fontSize:'11px',marginBottom:'8px',flexWrap:'wrap'}}>
            {offer.delivery_time && <span>🚚 <strong>{offer.delivery_time}</strong></span>}
            {offer.warranty_months && <span>🛡 <strong>{offer.warranty_months} luni garanție</strong></span>}
          </div>

          {/* TELEFON BLOCAT/DEBLOCAT */}
          {offer.is_accepted ? (
            <div style={{display:'flex',alignItems:'center',gap:'8px',background:'#DCFCE7',border:'0.5px solid #22C55E',borderRadius:'8px',padding:'8px 12px',marginBottom:'8px',fontSize:'12px',color:'#15803D'}}>
              <span>📞</span><span><strong>{offer.company_name}</strong> · <strong>{offer.phone_visible || offer.collab_phone}</strong> — Poți suna acum!</span>
            </div>
          ) : (
            <div style={{display:'flex',alignItems:'center',gap:'8px',background:'#F4F4F4',borderRadius:'8px',padding:'8px 12px',marginBottom:'8px',fontSize:'12px',color:'#888'}}>
              <span>🔒</span><span>Acceptă oferta pentru a vedea numărul de telefon</span>
            </div>
          )}

          {!offer.is_accepted && !selectedRequest?.accepted_offer_id && (
            <button onClick={()=>acceptOffer(offer.id)} style={{...s.btn,background:GOLD,color:DARK,fontSize:'12px',padding:'8px 18px'}}>
              ✓ Acceptă oferta
            </button>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'14px'}}>
        <div style={{fontSize:'20px',fontWeight:800}}>💬 Solicitările mele</div>
        <button onClick={()=>setView('new')} style={{...s.btn,background:GOLD,color:DARK}}>+ Solicitare nouă</button>
      </div>

      {msg && <div style={{background:'#DCFCE7',borderRadius:'8px',padding:'10px',fontSize:'12px',color:'#15803D',marginBottom:'12px'}}>{msg}</div>}

      {requests.length === 0 ? (
        <div style={{...s.card,textAlign:'center',padding:'40px'}}>
          <div style={{fontSize:'48px',marginBottom:'12px'}}>💬</div>
          <div style={{fontWeight:700,marginBottom:'6px'}}>Nu ai solicitări active</div>
          <div style={{fontSize:'12px',color:'#888',marginBottom:'16px'}}>Trimite o solicitare și colaboratorii îți vor răspunde cu oferte.</div>
          <button onClick={()=>setView('new')} style={{...s.btn,background:GOLD,color:DARK}}>+ Solicitare nouă</button>
        </div>
      ) : requests.map(req => (
        <div key={req.id} onClick={()=>loadOffers(req)}
          style={{...s.card,cursor:'pointer',borderLeft:`4px solid ${req.status==='accepted'?GREEN:req.status==='active'?GOLD:'#D3D1C7'}`}}
          onMouseOver={e=>e.currentTarget.style.borderColor=GOLD}
          onMouseOut={e=>e.currentTarget.style.borderColor=req.status==='accepted'?GREEN:req.status==='active'?GOLD:'#D3D1C7'}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'start',marginBottom:'6px'}}>
            <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
              <span style={{fontSize:'20px'}}>{TYPE_LABELS[req.request_type]?.icon || '📋'}</span>
              <div>
                <div style={{fontWeight:700,fontSize:'14px'}}>{TYPE_LABELS[req.request_type]?.label || req.request_type}</div>
                <div style={{fontSize:'11px',color:'#888',marginTop:'2px',fontFamily:'monospace'}}>
                  {req.plate_number && `${req.plate_number} · `}{req.brand} {req.model} {req.year}
                </div>
              </div>
            </div>
            <div style={{textAlign:'right'}}>
              <span style={{background:statusColors[req.status],fontSize:'10px',fontWeight:700,padding:'3px 9px',borderRadius:'7px',color:req.status==='accepted'?'#15803D':req.status==='active'?GOLD:'#888'}}>
                {statusLabels[req.status]}
              </span>
              {parseInt(req.offer_count) > 0 && (
                <div style={{fontSize:'11px',color:GREEN,fontWeight:700,marginTop:'4px'}}>
                  {req.offer_count} oferte · min {req.min_price} lei
                </div>
              )}
            </div>
          </div>
          <div style={{fontSize:'12px',color:'#555',lineHeight:1.5}}>{req.description?.substring(0,120)}...</div>
          <div style={{fontSize:'10px',color:'#aaa',marginTop:'6px'}}>{new Date(req.created_at).toLocaleDateString('ro-RO')} · 📍 {req.location}</div>
        </div>
      ))}
    </div>
  );
}
